import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[emailShare]'
})
export class EmailShareDirective {
  @Input() emailBody: string;
  @Input() emailSubject: string;
  constructor() { }

  @HostListener('click')
  onClick() {
      const encodedEmailSubject = encodeURIComponent(this.emailSubject);
      const encodedEmailBody = encodeURIComponent(`${this.emailBody}\n\n${window.location.href}`);
      const emailShareUrl = `mailto:?subject=${encodedEmailSubject}&body=${encodedEmailBody}`;
      window.location.href = emailShareUrl;
    
  }
}
